import * as Yup from "yup";

export type TFormFieldNames = "mode_of";
type TModeOf = "via_email" | "via_mobile";
export const formInitialValues = {
  mode_of : "via_mobile" as TModeOf
};

export const YupValidationSchema = Yup.object().shape({
});